<template>
  <div class="hr-distribution">
    <div v-if="isPcFlag" class="hr-distribution-pc">
      <div class="total-title">深耕于人事场景和分销场景</div>
      <div class="content">
        <div class="content-item" v-for="(item, index) in dataList" :key="index">
          <div class="title-tab">
            <div class="title">{{ item.title }}</div>
            <div class="tab-list">
              <p v-for="(a, b) in item.tabList" :key="b">{{ a }}</p>
            </div>
          </div>
          <div class="plan-box">
            <div class="plan-box-content">
              <div class="left">
                <div class="top">
                  <div class="line"></div>
                  <div class="text">{{ item.planTitle }}</div>
                </div>
                <div class="center">{{ item.planDesc }}</div>
                <div class="bottom">
                  <div class="desc-one">
                    <div class="desc-one-line" v-for="(c, d) in item.planListOne" :key="d">
                      <div class="point"></div>
                      <div class="text">{{ c }}</div>
                    </div>
                  </div>
                  <div class="desc-two">
                    <div class="desc-two-line" v-for="(e, f) in item.planListTwo" :key="f">
                      <div class="point"></div>
                      <div class="text">{{ e }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right">
                <div class="title">
                  <div class="left-line"></div>
                  <div class="center-text">{{ item.scenarioTitle }}</div>
                  <div class="right-line"></div>
                </div>
                <div class="imgs">
                  <div
                    v-for="(g, h) in item.scenarioImgs"
                    :style="{ background: `url(${g.img}) center center / cover no-repeat` }"
                    :key="h"
                  >
                    <p>{{ g.text }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="hr-distribution-h5"></div>
  </div>
</template>

<script>
export default {
  props: {
    isPcFlag: Boolean, // 是Pc还是H5
    dataList: Array,
  },
}
</script>

<style lang="less" scoped>
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
// pc样式
.hr-distribution {
  width: 100%;
  .hr-distribution-pc {
    width: 100%;
    .columnDisplay(center, center);
    .total-title {
      width: 100%;
      height: 72px;
      font-size: 34px;
      background: #de2221;
      color: #fff;
      .basisDisplay(center, center);
    }
    .content {
      width: 100%;
      .content-item {
        width: 100%;
        height: auto;
        .title-tab {
          width: 100%;
          background: linear-gradient(0deg, #f9f9f9 0%, #eaecf1 100%);
          padding: 62px 0 70px 0;
          .columnDisplay(center, center);
          .title {
            font-size: 32px;
            color: #0f0f0f;
            margin-bottom: 40px;
          }
          .tab-list {
            width: 100%;
            max-width: 1320px;
            white-space: pre-wrap;
            .basisDisplay(space-between, center);
            p {
              width: 300px;
              height: 70px;
              text-align: center;
              background: #ffffff;
              box-shadow: 3px 4px 13px 0px rgba(154, 164, 176, 0.19);
              border-radius: 9px;
              font-size: 20px;
              color: #0f0f0f;
              .basisDisplay(center, center);
            }
          }
        }
        .plan-box {
          padding: 50px 0 57px 0;
          background: #fff;
          .plan-box-content {
            max-width: 1320px;
            margin: 0 auto;
            .basisDisplay(center, center);
            .left {
              width: 355px;
              margin-right: 147px;
              .top {
                .basisDisplay(flex-start, center);
                .line {
                  width: 6px;
                  height: 31px;
                  background: #de2221;
                  margin-right: 15px;
                }
                .text {
                  font-size: 32px;
                  color: #0f0f0f;
                }
              }
              .center {
                font-size: 14px;
                color: #0f0f0f;
                margin: 28px 0 20px 0;
                white-space: pre-wrap;
                line-height: 20px;
              }
              .bottom {
                .basisDisplay(flex-start, flex-start);
                .desc-one,
                .desc-two {
                  line-height: 24px;
                  .desc-one-line,
                  .desc-two-line {
                    .basisDisplay(flex-start, center);
                    .point {
                      width: 6px;
                      height: 6px;
                      background: #de2221;
                      border-radius: 50%;
                      margin-right: 7px;
                    }
                    .text {
                      font-size: 14px;
                      color: #666666;
                    }
                  }
                }
                .desc-one {
                  margin-right: 30px;
                }
              }
            }
            .right {
              width: 715px;
              .title {
                width: 100%;
                .basisDisplay(center, center);
                margin-bottom: 18px;
                .left-line {
                  width: 247px;
                  height: 1px;
                  background: linear-gradient(90deg, #f9f9f9 30%, #666 100%);
                }
                .center-text {
                  font-size: 20px;
                  color: #666666;
                  margin: 0 25px;
                }
                .right-line {
                  width: 247px;
                  height: 1px;
                  background: linear-gradient(90deg, #666 30%, #f9f9f9 60%);
                }
              }
              .imgs {
                .basisDisplay(flex-start, center);
                flex-wrap: wrap;
                & > div {
                  width: 224px;
                  height: 107px;
                  margin: 5px 7px;
                  .basisDisplay(center, center);
                  font-size: 16px;
                  color: #ffffff;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
